
import { Component } from "@zoovu/runner-browser-api";
import Modal from "./modal.vue";

@Component({})
export default class InfoTextMobile extends Modal {}
